<template>
    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <inquirySupplierRequestMessage></inquirySupplierRequestMessage>
    </v-dialog>
</template>

<script>
    import inquirySupplierRequestMessage from './InquirySupplierRequestMessage.vue'

    // Settings Types
    import {
        InquirySupplierRequests
    } from '../../../store/namespace-helper'

    export default {
      name: 'inquirySupplierRequestDialog',
      components: {
        inquirySupplierRequestMessage
      },
      data () {
        return {
        }
      },
      methods: {
      },
      computed: {
        dialog () {
          return this.$store.getters[InquirySupplierRequests.getters.getOpenInquirySupplierRequestMessageDialogState]
        }
      },
      beforeDestroy () {

      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Distribution/SupplierRequests/InquirySupplierRequestDialog.vue